import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
const SearchButton = ({
  buttonValue,
  onClick,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={
        (disabled
          ? "cursor-not-allowed border text-white bg-primary border-primary"
          : "text-white bg-primary border-primary") +
        `hover:scale-90 sm:text-xxs  uppercase rounded-full justify-between w-auto gap-x-2 items-center bg-primary text-white hover:text-white flex hover:bg-tertiary md:text-xs font-medium border shadow-md px-3 py-1 sm:px-2   transition duration-500 ease select-none focus:outline-none focus:shadow-outline ${className}`
      }
    >
      <MagnifyingGlassIcon className=" h-4 w-4 " />
      <div className=" self-center ">{buttonValue}</div>
    </button>
  );
};
export default SearchButton;
